const prototypeRoutes = [
  {
    path: "/capabilities",
    title: "Capabilities Deck",
    source:
      "https://embed.figma.com/proto/RcUeE0EYKvDBXBx71zBnFE/P-%E2%80%A2-Walkthrough?node-id=1190-12111&p=f&viewport=224%2C456%2C0.02&scaling=contain&content-scaling=fixed&starting-point-node-id=1190%3A12111&page-id=1190%3A10518&embed-host=share&theme=dark&footer=false",
  },
  {
    path: "/walkthrough",
    title: "Portfolio Walkthrough",
    source:
      "https://embed.figma.com/proto/RcUeE0EYKvDBXBx71zBnFE/P-%E2%80%A2-Walkthrough?node-id=62-3857&viewport=224%2C456%2C0.02&scaling=contain&content-scaling=fixed&starting-point-node-id=62%3A3857&page-id=62%3A3848&embed-host=share&theme=dark&footer=false",
  },
];

export default prototypeRoutes;
